import { Routes } from "@angular/router";
import { getAllPlansResolver } from "@app/applications/payment/domains/purchase/resolvers/get-all-plans.resolver";
import { getAllPaymentMethodsResolver } from "@app/shared/payment-method/resolvers/get-all-payment-methods.resolver";
import { PaymentMethodsService } from "@app/shared/payment-method/services/payment-methods.service";
import { PlanService } from "@app/applications/payment/domains/purchase/services/plan.service";
import { INVOICE_PAYMENT_STATUS_DATA_SHAPE } from "@app/shared/payment/datashapes/invoice.datashape";
import { getInvoiceResolver } from "@app/shared/payment/resolvers/get-invoice.resolver";
import { getCreditPurchaseResolver } from "@app/applications/payment/domains/purchase/resolvers/get-credit-purchase.resolver";
import { CreditPurchaseService } from "@app/applications/payment/domains/purchase/services/credit-purchase.service";
import { PaymentService } from "@app/shared/payment/services/payment.service";
import { CurrencyPipe } from "@angular/common";
import { myBillingAccountResolver } from "@app/shared/billing-account/resolvers/my-billing-account.resolver";
import { BillingAccountService } from "@app/shared/billing-account/services/billing-account.service";
import { BillingComponent } from "@app/applications/payment/domains/billing/pages/billing/billing.component";
import { InvoiceService } from "@app/applications/payment/services/invoice.service";

export const paymentRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./domains/purchase/pages/purchase/purchase.component").then(c => c.PurchaseComponent),
    resolve: {
      plans: getAllPlansResolver,
      paymentMethods: getAllPaymentMethodsResolver,
      myBillingAccount: myBillingAccountResolver,
    },
    providers: [PlanService, PaymentMethodsService, BillingAccountService],
  },
  {
    path: "subscription-payment-status/:invoiceId",
    loadComponent: () =>
      import("./domains/purchase/pages/subscription-payment-status/subscription-payment-status.component").then(
        c => c.SubscriptionPaymentStatusComponent
      ),
    data: {
      getInvoiceOptions: { dataShape: INVOICE_PAYMENT_STATUS_DATA_SHAPE },
    },
    resolve: {
      invoice: getInvoiceResolver(route => route.paramMap.get("invoiceId")),
      paymentMethods: getAllPaymentMethodsResolver,
    },
    providers: [InvoiceService, PaymentMethodsService],
  },
  {
    path: "credit-payment-status/:purchaseId",
    loadComponent: () =>
      import("./domains/purchase/pages/credit-payment-status/credit-payment-status.component").then(c => c.CreditPaymentStatusComponent),
    resolve: {
      creditPurchaseInput: getCreditPurchaseResolver,
    },
    providers: [CurrencyPipe, PaymentService, CreditPurchaseService],
  },
  {
    path: "complete-credit-payment",
    loadComponent: () =>
      import("./domains/purchase/pages/complete-credit-payment/complete-credit-payment.component").then(c => c.CompleteCreditPaymentComponent),
    providers: [CreditPurchaseService],
  },
  {
    path: "billing",
    component: BillingComponent,
    runGuardsAndResolvers: "always",
    resolve: {
      paymentMethods: getAllPaymentMethodsResolver,
      myBillingAccount: myBillingAccountResolver,
    },
    providers: [PaymentMethodsService, BillingAccountService],
    loadChildren: () => import("./domains/billing/billing.routes").then(m => m.billingRoutes),
  },
];
